module.exports = __webpack_public_path__ + "img/ca.5d08ccab.svg";